import { generatePath } from 'react-router-dom'

import { AcornsIcon } from '@acorns/icons'
import { GetRemoteStringFunction } from '@acorns/web-utils'

import { FormattedDisplayedTheme } from 'pages/portfolio/types'
import { routes } from 'router/routes'
import {
  PORTFOLIO_EDIT_BITCOIN_BUTTON,
  PORTFOLIO_EDIT_RISK_BUTTON,
  PORTFOLIO_EDIT_STOCKS_AND_ETFS_BUTTON,
  PORTFOLIO_EDIT_THEME_BUTTON,
} from 'utils/testing/testIDs'

const EditPortfolioDrawerOptions = (
  getRemoteString: GetRemoteStringFunction,
  portfolioTheme: string,
  portfolioRisk: string,
  isCryptoInPortfolio: boolean,
  isCustomPortfolio: boolean,
) => {
  const withPassionsOptions = [
    {
      header: getRemoteString({
        key: 'portfolio.edit.securities.title',
      }),
      subHeader: getRemoteString({
        key: 'portfolio.edit.securities.subtitle',
      }),
      icon: AcornsIcon.Icon.UtilityPortfolio,
      url: routes.customPortfolio.builder,
      testId: PORTFOLIO_EDIT_STOCKS_AND_ETFS_BUTTON,
    },
    {
      header: getRemoteString({
        key: 'portfolio.edit.bitcoin.title',
      }),
      subHeader: getRemoteString({
        key: 'portfolio.edit.bitcoin.subtitle',
      }),
      icon: AcornsIcon.Icon.UtilityCrypto,
      url: isCryptoInPortfolio
        ? generatePath(routes.invest.fund, {
            fundName: 'BITO',
          })
        : routes.portfolio.crypto.lander,
      testId: PORTFOLIO_EDIT_BITCOIN_BUTTON,
    },
    {
      header: getRemoteString({
        key: 'portfolio.edit.risk.title',
      }),
      subHeader: portfolioRisk,
      icon: AcornsIcon.Icon.UtilityRisk,
      url: routes.portfolio.changePortfolioRisk,
      testId: PORTFOLIO_EDIT_RISK_BUTTON,
    },
    ...(portfolioTheme === FormattedDisplayedTheme.SUSTAINABLE
      ? [
          {
            header: getRemoteString({
              key: 'portfolio.edit.theme.title',
            }),
            subHeader: getRemoteString({
              key: 'portfolio.edit.theme.subtitle',
              variables: [portfolioTheme],
            }),
            icon: AcornsIcon.Icon.UtilityTheme,
            url: routes.portfolio.changePortfolioTheme,
            testId: PORTFOLIO_EDIT_THEME_BUTTON,
          },
        ]
      : []),
  ]

  const withoutPassionsOptions = [
    {
      header: getRemoteString({
        key: 'portfolio.edit.bitcoin.title',
      }),
      subHeader: getRemoteString({
        key: 'portfolio.edit.bitcoin.subtitle',
      }),
      icon: AcornsIcon.Icon.UtilityCrypto,
      url: isCryptoInPortfolio
        ? generatePath(routes.invest.fund, {
            fundName: 'BITO',
          })
        : routes.portfolio.crypto.lander,
      testId: PORTFOLIO_EDIT_BITCOIN_BUTTON,
    },
    {
      header: getRemoteString({
        key: 'portfolio.edit.risk.title',
      }),
      subHeader: portfolioRisk,
      icon: AcornsIcon.Icon.UtilityRisk,
      url: routes.portfolio.changePortfolioRisk,
      testId: PORTFOLIO_EDIT_RISK_BUTTON,
    },
    ...(portfolioTheme === FormattedDisplayedTheme.SUSTAINABLE
      ? [
          {
            header: getRemoteString({
              key: 'portfolio.edit.theme.title',
            }),
            subHeader: getRemoteString({
              key: 'portfolio.edit.theme.subtitle',
              variables: [portfolioTheme],
            }),
            icon: AcornsIcon.Icon.UtilityTheme,
            url: routes.portfolio.changePortfolioTheme,
            testId: PORTFOLIO_EDIT_THEME_BUTTON,
          },
        ]
      : []),
  ]
  return isCustomPortfolio ? withPassionsOptions : withoutPassionsOptions
}

export { EditPortfolioDrawerOptions }
